const config = {
  env: "local",
  // apiUrl: "http://localhost:8080/admin/",
  // apiUrl: "http://15.206.68.199:5641/admin/",
  	apiUrl: "https://pruden-api.chabhiwala.com/admin/",
  // apiUrl: "https://api.mentblue.com/admin",
  // apiUrl: "http://115.246.77.236:5641/admin",
  // apiUrl: "https://api.amourtrendss.com/admin/",
};

export default config;
